<template>
  <div class="popWrap nowOpen">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">[필수] 개인정보 수집 및 이용 동의</h1>
          </div>
          <div class="popBody full">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section class="termsDetail">
                <span class="txt">
                  전화상담을 위해서는 아래 정보 항목에 대한 동의가 필요합니다. 해당 정보 사용에 대한 동의를 거부할 권리가 있으나, 미 동의 시 상담
                  서비스 이용이 불가능합니다.
                </span>
                <!-- table (s) -->
                <table class="tableY line ac">
                  <tbody>
                    <tr>
                      <td class="th">수집∙이용 항목</td>
                    </tr>
                    <tr>
                      <td>신청인 정보(이름, 휴대폰번호)</td>
                    </tr>
                    <tr>
                      <td class="th">수집∙이용 목적</td>
                    </tr>
                    <tr>
                      <td>고객이 신청한 서비스 이행을 위한 상담 및 접수</td>
                    </tr>
                    <tr>
                      <td class="th">보유기간</td>
                    </tr>
                    <tr>
                      <td>
                        이용 목적 달성 후 지체 없이 파기.
                        <br />
                        단, 이용 목적 달성 후에는 소비자의 불만 또는 분쟁처리, 법령상 의무 이행을 위하여만 보유.이용됩니다.
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- table (e) -->
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="$emit('agree')">동의</button>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallServiceTermPop',
};
</script>
